module.exports = __webpack_public_path__ + "static/media/nea-puun-alla.78673c03.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/nea-puun-alla.jpg
 ** module id = 346
 ** module chunks = 0
 **/